import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [

    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('../views/HomePage.vue')
    },
    {
        path: '/activity',
        name: 'Activity',
        component: () => import('../views/ActivityPage.vue'),
        children: [
            {
                path: '/entryForm',
                name: 'EntryForm',
                component: () => import('../components/EntryForm.vue')
            }
        ]
    },
    {
        path: '/news',
        name: 'News',
        component: () => import('../views/NewsPage.vue')
    },
    {
        path: '/download',
        name: 'Download',
        component: () => import('../views/DownloadCenter.vue')
    },
    {
        path: '/profile',
        name: 'Profile',

        component: () => import('../views/ProfilePage.vue'),
        children: [
            {
                path: '',
                redirect: '/registration'
            },
            {
                path: '/registration',
                name: 'MyRegistration',
                component: () => import('../views/MyRegistration.vue')
            },
            {
                path: '/favorites',
                name: 'MyFavorites',
                component: () => import('../views/MyFavorites.vue')
            },
            {
                path: '/userProfile',
                name: 'UserProfile',
                component: () => import('../views/UserProfile.vue')
            },
            {
                path: '/security',
                name: 'AcctSecurity',
                component: () => import('../views/AcctSecurity.vue')
            }
        ]
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: () => import('../views/NewsDetail.vue'),
        props: true,
    },
    {
        path: '/activity/:id',
        name: 'ActivityDetail',
        component: () => import('../views/ActivityDetail.vue'),
        props: true,
    },
    {
        path: '/error',
        name: 'ErrorPage',
        component: () => import('../views/ErrorPage.vue'),
        props: true,
    },
    {
        path: '/login',
        name: 'LoginPage',
        component: () => import('../views/LoginPage.vue'),
        props: true,
    },
    {
        // 评委评分页面
        path: '/score',
        name: 'JudgeScorePage',
        component: () => import('../views/JudgeScorePage.vue'),
        props: true,
    },
    {
        // 报名
        path: '/registrationPage',
        name: 'RegisitrationPage',
        component: () => import('../views/RegisitrationPage.vue'),
        props: true,
    },
    {
        // 电子签名
        path: '/signPage',
        name: 'SignPage',
        component: () => import('../views/SignPage.vue'),
        props: true,
    },
    {
        // 我的评审
        path: '/approval',
        name: 'MyApproval',
        component: () => import('../views/MyApprovalPage.vue'),
        props: true,
    }
]

const router = createRouter({
    // mode: 'history',
    // history: createWebHistory(),
    history: createWebHashHistory(), // 修改这里
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // 使用浏览器前进/后退按钮时恢复滚动位置
            return savedPosition;
        } else {
            // 普通导航时滚动到顶部
            return { top: 0 };
        }
    }
})

export default router